<template>
  <Dialog
    v-show="isModalOpen"
    showClose
    :clickOutside="true"
    @close="close"
    class="customer-reviews-modal"
    :align-bottom="mobile"
  >
    <template v-slot:header>
      <SectionHeading id="toc-customer-reviews" class="heading" icon="icon-multiple-users-1" title="All trip reviews" />
    </template>

    <ItineraryCustomerReviews expand />
  </Dialog>
</template>

<script setup>
import { useItineraryStore } from '@/stores/itinerary.js'
import { Dialog } from '@/components/Theme'
import { computed } from 'vue'
import ItineraryCustomerReviews from '@/modules/Itinerary/ItineraryCustomerReviews.vue'
import SectionHeading from '@/modules/Itinerary/Components/SectionHeading.vue'
import { useResponsive } from '@/helpers/vueHelpers.js'

const { mobile } = useResponsive()
const store = useItineraryStore()

const isModalOpen = computed(() => store.isReviewModalOpen)

const close = () => {
  store.closeReviewModel()
}
</script>

<style lang="scss" scoped>
.theme-dialog.customer-reviews-modal {
  :deep(.modal__container) {
    min-width: min(80vw, $content-width);
  }
}
</style>
